import { Tooltip, type TooltipProps } from "@heroui/react";

/**
 * 補足を出すだけのツールチップ。**クリックは下の要素へ通す**。
 *
 * HeroUI の Tooltip は吹き出しを実体のある要素として重ねるので、吹き出しが
 * ボタンや隣のセルに掛かると、そこを押したつもりのクリックを吹き出しが
 * 受け取ってしまう。見せるだけの要素なのでポインタ操作の対象から外す。
 *
 * ツールチップを出す場所では、素の `Tooltip` ではなくこれを使う。
 */
export default function HintTooltip({ classNames, ...props }: TooltipProps) {
  return (
    <Tooltip
      {...props}
      classNames={{
        ...classNames,
        // base（role="tooltip" が付く外側）に効かせないと素通りしない。content だけ
        // だと外側が当たり判定を持ったままになる（実際に測って確かめてある）。
        base: ["pointer-events-none", classNames?.base].filter(Boolean).join(" "),
        content: ["pointer-events-none", classNames?.content].filter(Boolean).join(" "),
      }}
    />
  );
}
